import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class UtilityAgyoService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getStatisticheByYear(year){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/agyo/${year}/statistiche`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async downloadFileCsv(date){
    const parts = date.split('-')

    const url = `${this.baseUrl}/utility/agyo/${parts[0]}/${parts[1]}/csv`
  
    try {
      const res = await this.http({
        url,
        method: 'GET',
        responseType: 'blob',
      })
      this.filemanager.download(res,  {type: 'text/csv'})

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getAssentiAgyoByMonth(date){
    const parts = String(date).split('-')
    const url = `${this.baseUrl}/utility/agyo/${parts[0]}/${parts[1]}/assenti`
    let data = {
      periodo: {},
      totale: 0,
      numeri: [],
    }

    try {
      let res = await this.http.get(url)
      res = res.data
      data = res.data || data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return data
    }
  }

  async getScartateByYear(year){
    let items = []

    const url = `${this.baseUrl}/utility/agyo/${year}/scartate`

    try {
      let res = await this.http.get(url)
      res = res.data
      items = res.data || []
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return items
    }
  }

  async resetScartateByNumeri(numeriFattura = []){
    const url = `${this.baseUrl}/utility/agyo/reset-scartate-by-numeri`

    try {
      let res = await this.http.post(url, {
        numeri_fattura: numeriFattura,
      })
      res = res.data
      return res.data || {}
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return null
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getInvoiceFromAgyo(id_sdi){

    const url = `${this.baseUrl}/utility/agyo/${id_sdi}/fattura/download`
  
    try {
      const res = await this.http({
        url,
        method: 'GET',
        responseType: 'blob',
      })

      return res;
 
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

}
